import styled from "styled-components"
import { Link } from "gatsby"

const Wrapper = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  margin-top: 100px;

  > a {
    align-items: center;
    background-color: ${props => props.theme.colors.primary};
    border-radius: 30px;
    color: #fff;
    display: flex;
    flex-shrink: 0;
    font-size: 12px;
    height: 30px;
    justify-content: center;
    transition: opacity 0.3s;
    width: 30px;

    @media only screen and (min-width: ${props => props.theme.mq.small}) {
      font-size: 14px;
    }

    .no-touchevents &:hover {
      opacity: 0.7;
    }
  }
`

const Numbers = styled.div`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: 0 30px;

  @media only screen and (min-width: ${props => props.theme.mq.xsmall}) {
    margin: 0 90px;
  }

  span {
    display: block;
    font-size: 12px;
    font-weight: ${props => props.theme.title.w};
    margin-right: 5px;

    @media only screen and (min-width: ${props => props.theme.mq.small}) {
      font-size: 14px;
      margin-right: 10px;
    }
  }
`

const Number = styled(Link)`
  color: ${props => props.theme.colors.grey};
  font-size: 12px;
  font-weight: ${props => props.theme.title.w};
  margin: 2px 7px;
  transition: color 0.3s;

  @media only screen and (min-width: ${props => props.theme.mq.small}) {
    font-size: 14px;
    margin: 5px 10px;
  }

  &.active {
    color: ${props => props.theme.colors.primary};
  }

  .no-touchevents &:hover {
    color: ${props => props.theme.colors.primary};
  }
`

export const sPagination = {
  Wrapper,
  Numbers,
  Number,
}
